import React from "react";

export const TripVerificationIcon = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1147_2381)">
        <path
          d="M15.5837 7.33317V4.58317C15.5837 4.34006 15.4871 4.1069 15.3152 3.93499C15.1433 3.76308 14.9101 3.6665 14.667 3.6665H5.50033C5.0141 3.6665 4.54778 3.85966 4.20396 4.20347C3.86015 4.54729 3.66699 5.01361 3.66699 5.49984M3.66699 5.49984C3.66699 5.98607 3.86015 6.45238 4.20396 6.7962C4.54778 7.14002 5.0141 7.33317 5.50033 7.33317H16.5003C16.7434 7.33317 16.9766 7.42975 17.1485 7.60166C17.3204 7.77356 17.417 8.00672 17.417 8.24984V10.9998M3.66699 5.49984V16.4998C3.66699 16.9861 3.86015 17.4524 4.20396 17.7962C4.54778 18.14 5.0141 18.3332 5.50033 18.3332H16.5003C16.7434 18.3332 16.9766 18.2366 17.1485 18.0647C17.3204 17.8928 17.417 17.6596 17.417 17.4165V14.6665"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.333 11V14.6667H14.6663C14.1801 14.6667 13.7138 14.4735 13.37 14.1297C13.0262 13.7859 12.833 13.3196 12.833 12.8333C12.833 12.3471 13.0262 11.8808 13.37 11.537C13.7138 11.1932 14.1801 11 14.6663 11H18.333Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2381">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
